export class Sort {
  field: string;
  order: string;
}
